import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineMail } from 'react-icons/hi';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-logo">YIBE</h3>
          <p className="footer-tagline">Handcrafted fashion designed to make you stand out. Every piece is sewn with love, passion, and attention to detail.</p>
        </div>

        <div className="footer-section">
          <h4>Shop</h4>
          <Link to="/shop">All Pieces</Link>
          <Link to="/shop?category=dresses">Dresses</Link>
          <Link to="/shop?category=sets">Sets</Link>
          <Link to="/shop?category=gowns">Gowns</Link>
        </div>

        <div className="footer-section">
          <h4>Customer Care</h4>
          <Link to="/contact">Contact Us</Link>
          <Link to="/shipping">Shipping Info</Link>
          <Link to="/returns">Returns & Exchanges</Link>
          <Link to="/faq">FAQ</Link>
        </div>

        <div className="footer-section">
          <h4>Stay Connected</h4>
          <p>Subscribe to get notified about new drops and exclusive offers.</p>
          <div className="newsletter-form">
            <input type="email" placeholder="Your email" />
            <button><HiOutlineMail size={20} /></button>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 YIBE. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
